const MailClosed = () => (
  <>
    <path
      fill="currentColor"
      d="M4.616 19q-.69 0-1.153-.462A1.57 1.57 0 0 1 3 17.384V6.616q0-.69.462-1.153A1.57 1.57 0 0 1 4.616 5h14.77q.69 0 1.152.463.463.462.463 1.152v10.77q0 .69-.462 1.152a1.57 1.57 0 0 1-1.154.463zM20 6.885l-7.552 4.944q-.105.056-.214.093a.7.7 0 0 1-.234.037.7.7 0 0 1-.234-.037 1.5 1.5 0 0 1-.214-.093L4 6.884v10.5a.6.6 0 0 0 .173.443.6.6 0 0 0 .442.173h14.77a.6.6 0 0 0 .442-.173.6.6 0 0 0 .173-.443zM12 11l7.692-5H4.308zM4 7.096v-.811.034-.05z"
    />
  </>
)
export default MailClosed
